﻿$.validator.setDefaults({
    ignore: '.ignore-validate'
});

(function ($) {
    window.onload = winLoaded();
    function winLoaded() {
        setCaptcha();
    }

    function setCaptcha() {
        if ($('#captcha').length > 0) {
            $('#captcha').prop('src', '/captcha?' + (new Date()).getTime());
        }
    }

    $(function () {
        $('#VerifyCode').prop('autocomplete', 'off');

        $('.reset-captcha').click(function () {
            setCaptcha();
        });

        $(':input[type="number"]').keypress(function (e) {
            var charCode = e.keyCode;
            if ($(this).val().length === parseInt($(this).prop('maxlength'), 10) && charCode !== 13) {
                return false;
            }
        });

        $('form').on('keyup',
            '.toupper',
            function (e) {
                let $this = $(this);
                var val = $this.val();
                $this.val(val.replace(/[^a-z]/ig, '').toUpperCase());
            });

        $('.block-form').submit(function () {
            let $this = $(this);
            if (!$this.data('confirm') && typeof $this.valid === "function" && $this.valid()) {
                block();
            }
        });
    });
})(jQuery);